import { TagMuted } from '@components/core-ui/Tag/variations/TagMuted';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { StyledLink } from './styles/StyledLink';
import { Wrapper } from './styles/Wrapper';
import { ScriberDashboardJobDto } from 'app/API';

type TProps = {
  jobs?: ScriberDashboardJobDto[];
};

export const JobsList = ({ jobs = [] }: TProps) => {
  const { organization } = useAuthContext();
  return (
    <Wrapper>
      {!jobs.length ? <div className="jobsList-noJobs">No Jobs</div> : null}
      {jobs.length ? (
        <Scrollbars autoHeight autoHeightMin={30} autoHeightMax={320}>
          <div className="jobsList-wrapper">
            {jobs.map((cdj) => {
              const workspace = cdj.workspace ? cdj.workspace.name : null;
              const deadline = cdj.deadline ? `Deadline: ${getAmericanTime(cdj.deadline, false)}` : null;
              return (
                <div className="jobsList-item" key={cdj.id}>
                  <StyledLink to={routes.jobDetails.make(organization?.slug ?? '', cdj.workspace?.slug ?? '', cdj.id)}>
                    {cdj.name}
                  </StyledLink>
                  {workspace ? (
                    <div className="jobsList-item-workspace-wrapper">
                      <TagMuted
                        className="max-w-full"
                        style={{
                          background: 'var(--color-chip-workspace-bg)',
                          color: 'var(--color-text-muted)',
                        }}
                      >
                        {workspace}
                      </TagMuted>
                    </div>
                  ) : null}
                  {deadline ? <div className="jobsList-item-deadline">{deadline}</div> : null}
                </div>
              );
            })}
          </div>
        </Scrollbars>
      ) : null}
    </Wrapper>
  );
};
